import { Fragment } from 'react';
import { IconButton, useEventCallback } from '@mui/material';
import { createSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { ActionProps } from 'shell/view-models/actions-props';
import { Visibility as VisibilityIcon } from '@mui/icons-material';
import { useFilterTable } from 'shell/hooks/use-filter-table';
import { FiltersFormPerson } from 'shell/view-models/search-anpr';
import { DefaultFilterTable } from 'shell/constants/person-search';

const ActionsList = ({
  cell,
  filterPersonForm,
  pathname = '/iscrizioni/famiglia/nascita',
}: ActionProps): React.ReactElement => {
  const navigate = useNavigate();

  const personFilterTable = useFilterTable<FiltersFormPerson>();

  const onVisibilityPress = useEventCallback(() => {
    personFilterTable.setValues(DefaultFilterTable);
    navigate({
      pathname,
      search: `?${createSearchParams({
        ricercaNazionale:
          filterPersonForm?.commonSearch?.isNationalResearch?.toString() ||
          filterPersonForm?.subjectData?.isNationalResearch?.toString() ||
          'false',
        codiceFiscale: cell?.fiscalCode || '',
        idSchedaSoggettoANPR: cell?.anpr || '',
      })}`,
    });
  });

  return (
    <Fragment>
      <IconButton
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          onVisibilityPress();
        }}
        aria-label="Visualizza elemento"
        aria-haspopup="true"
        style={{
          padding: '4px',
        }}
      >
        <VisibilityIcon />
      </IconButton>
    </Fragment>
  );
};

ActionsList.displayName = 'Action list family page component';

export default ActionsList;
